import { render, staticRenderFns } from "./NewsletterTemplate.vue?vue&type=template&id=cd293214&scoped=true"
import script from "./NewsletterTemplate.vue?vue&type=script&lang=js"
export * from "./NewsletterTemplate.vue?vue&type=script&lang=js"
import style0 from "./NewsletterTemplate.vue?vue&type=style&index=0&id=cd293214&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd293214",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2326903440/src/bitbucket.org/Modis-ito/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cd293214')) {
      api.createRecord('cd293214', component.options)
    } else {
      api.reload('cd293214', component.options)
    }
    module.hot.accept("./NewsletterTemplate.vue?vue&type=template&id=cd293214&scoped=true", function () {
      api.rerender('cd293214', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/drc/pages/controlPanel/landingPage/NewsletterTemplate.vue"
export default component.exports